import axios from 'axios'

const state = {}

const mutations = {}

const actions = {
  async message({}, msg) {
    await axios.post('/api/log', { msg })
  },
}

const getters = {}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
